import { ScoreType } from '../../../../../../store/admin/eventFormats/store';
import { IMetaFormat } from '../../../../../../store/admin/roundFormats/store';
import { IContestSelectorOption } from '../BoundActionCreators/setContestSelectorOptions';

export const getContestSelectorOptions = (roundFormats: IMetaFormat[]) =>
  roundFormats
    .filter(metaFormat => metaFormat.format.isContest)
    .reduce((acc: IContestSelectorOption[], metaFormat) => {
      const {
        scoreTypes,
        format: { prefix, name }
      } = metaFormat;

      const contestScoreTypes = prefix === 'ctp' ? [scoreTypes[0]] : scoreTypes;

      const contestSelectorOptions: IContestSelectorOption[] = contestScoreTypes.map(scoreType => ({
        label: `${name} ${ScoreType[scoreType]}`,
        value: {
          metaFormat,
          scoreType
        }
      }));
      return [...acc, ...contestSelectorOptions];
    }, []);
